export default class PlanoConta {
    
    constructor(model = null){
        this.id = 0;
        this.empresaId = 0;
        this.nome = '';
        this.tipo = '';
        this.descricao = '';

        if (!model)
            return;
        
        this.id = model.id ? model.id : 0;
        this.empresaId = model.empresaId;
        this.nome = model.nome; 
        this.tipo = model.tipo;
        this.descricao = model.descricao;
        this.itens = model.itens;
    }
}